export default __webpack_public_path__ + "static/media/noChatIllustration.46195ad2.gif";